import { PromoProvider } from '@/context/PromoContext';
import { Outlet } from 'react-router-dom';

const BasePromo = () => {
  return (
    <PromoProvider>
      <Outlet />
    </PromoProvider>
  );
};

export default BasePromo;
